import { useMemo, useState, useEffect } from 'react';
import * as amplitude from '@amplitude/analytics-browser';

import { NOTIFICATIONS_EVENTS } from '@app/dashboard/constants/tracking_events/notifications';
import { useMerchantFlags } from '@app/dashboard/hooks/useMerchantFlags';
import type {
  TMerchantFlags,
  TNotificationFlags,
} from '@app/dashboard/types/innerLayout/notifications';

import { formatMerchantFlags } from './utils.js';

import Header from './Header';
import NotificationSettings from './NotificationSettings';
import Footer from './Footer';

import styles from './Notifications.module.scss';

export const Notifications = () => {
  const { flagsQuery: data } = useMerchantFlags();

  const merchantFlags = useMemo(() => {
    return formatMerchantFlags(data?.data) as {
      [key in TNotificationFlags]: boolean;
    };
  }, [data]);

  const [updatedFlags, setUpdatedFlags] = useState<TMerchantFlags | undefined>(
    undefined
  );

  useEffect(() => {
    amplitude.track(NOTIFICATIONS_EVENTS.NOTIFICATION_OPENED);
  }, []);

  return (
    <div className={styles['notifications']}>
      <Header />
      <NotificationSettings
        merchantFlags={merchantFlags}
        updatedFlags={updatedFlags}
        setUpdatedFlags={setUpdatedFlags}
      />
      <Footer
        merchantFlags={merchantFlags}
        updatedFlags={updatedFlags}
        setUpdatedFlags={setUpdatedFlags}
      />
    </div>
  );
};
